export const READONLY = import.meta.env.VITE_READONLY === "true";
export const LS_USERNAME_KEY = "wb_username";
